import React from 'react';
import { Box, Typography } from '@mui/material';
// import { Link } from 'react-router-dom';
import BackButton from './BackButton';
import LeftDrawer from './LeftDrawer';
import { colors } from '../styles/colors';
import { LiComponent } from './HolidayType';
import { linkBaseUrl } from '../constants/menuItems';
const MobileHolidayTypes = () => {
  const [showResults, setShowResults] = React.useState(false);
  return (
    <>
      {showResults ? (
        <LeftDrawer />
      ) : (
        <Box
          sx={{
            '& ul': { listStyle: 'none' },
            '& .heading': { fontSize: '20px' },
            '& a': {
              textDecoration: 'none',
            },
            '& .side_ul': {
              padding: '0 0 30px 30px',
              borderLeft: '1px solid #939292',
            },

            '& .bottom_title': {
              color: colors.basics.primary,
              pt: '15px',
            },
          }}
        >
          <Box pb='20px' pt='20px' ml='10px' onClick={() => setShowResults(true)}>
            <BackButton />
          </Box>
          <Box p='15px 10px'>
            <Typography
              variant='subtitle2'
              className='heading'
              fontSize='20px'
              color='#303030'
              fontWeight={500}
            >
              Choose a holiday type
            </Typography>
            <Box
              p='20px 10px'
              justifyContent=' space-between'
              sx={{
                '& ul': {
                  '& li ': { padding: '0 0 1.25rem', '& a': { fontSize: '16px', color: '#303030' } },
                },
                'ul li a': {
                  '&:hover': {
                    color: colors.basics.primary,
                  },
                },
              }}
            >
              <ul className='first_ul'>
                <LiComponent name='Adult Only Holidays' href={`${linkBaseUrl}adult-only-holidays`} />
                <LiComponent name='All Inclusive Holidays' href={`${linkBaseUrl}all-inclusive-holidays`} />
                <LiComponent name='Cruise Holidays' href={`${linkBaseUrl}cruise-holidays/cruises`} />
                <LiComponent name='Family Holidays' href={`${linkBaseUrl}family-holidays`} />
                <LiComponent name='Honeymoons' href={`${linkBaseUrl}honeymoons`} />
                <LiComponent name='Luxury Holidays' href={`${linkBaseUrl}luxury-holidays`} />
                <LiComponent name='Tours' href={`${linkBaseUrl}tours`} />
                <LiComponent
                  name='Twin & Multi Centre Holidays'
                  href={`${linkBaseUrl}twin-multi-centre-holidays`}
                />
                <LiComponent name='Villa Holidays' href={`${linkBaseUrl}villa-holidays`} />

                <LiComponent name='Weddings' href={`${linkBaseUrl}weddings`} />
              </ul>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default MobileHolidayTypes;
